module.exports = __webpack_public_path__ + "static/img/2.7c2a231.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/zh/2.png
// module id = 6nu3
// module chunks = 0